import React, { Component } from 'react';
import {connect} from 'react-redux';
import EffectsComponent from 'components/effects/EffectsComponent.js';
import DocLink from './DocLink.js';
import EffectsChainChooser from 'components/effects/EffectsChainChooser.js';
import MiniTrackComponent from './MiniTrackComponent.js';
import {setShowTrackEffects} from 'actions/index.js';
import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import {
    setSelectedEffect,
    } from 'actions/index.js';

class EffectsDocumentation extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.sequencerEngine.select(0, 0);
        let scripting = this.props.sequencerEngine.scripting;
        scripting.viCommand('d');
        scripting.viCommand('d');
        scripting.viCommand('t');
        scripting.viCommand('l');
        scripting.viCommand('t');
        scripting.viCommand('l');
        scripting.viCommand('t');
        scripting.viCommand('l');
        scripting.viCommand('t');
        scripting.viCommand('l');
        scripting.viCommand('t');
        scripting.viCommand('l');
        scripting.viCommand('t');
        scripting.viCommand('l');
        scripting.viCommand('t');
        scripting.viCommand('l');
        this.props.sequencerEngine.store.dispatch(
            setShowTrackEffects(0, true));
    }

    componentWillUnmount() {
        this.props.sequencerEngine.store.dispatch(
            setShowTrackEffects(0, false));
    }

    get track() {
        return this.props.sequencerEngine.tracks[0];
    }

    getEffectIfAny(name) {
        if (this.track) {
            return this.track.effects.find(
                x => x.name === name);
        }

        return undefined;
    }

    getEffect(name) {
        let effect = this.getEffectIfAny(name);
        if (effect) {
            return (
                <EffectsComponent.EffectComponent
                  sequencerEngine={this.props.sequencerEngine}
                  onDeleteEffect={() => []}
                  effect={effect}
                  track={this.track}/>
            );
        }
        return (
            <div
              onClick={() => this.addEffect(name)}
              className="click-effect">
              <div>
                Click To Add {name} Effect
              </div>
            </div>);
    }

    addEffect(name) {
        let effect = initializeEffect(name, this.props.sequencerEngine);
        effect.enable(true);
        if (effect.wetParameter) {
            effect.wetParameter.set(1);
        }
        this.track.effectsChain.addEffect(effect);
        this.setState(this.state);
        this.props.setSelectedEffect(effect.id);

        if (!this.props.sequencerEngine.playing) {
            this.props.sequencerEngine.play();
        }
    }

    render() {
        let track = this.props.sequencerEngine.tracks[0];
        return (
            <div className="effects-documentation">
              <p>
                Processing sounds with effects is a key part of making music.
              </p>
              <p>
                Zequencer has many effects. To start using them, click the <b>FX button</b> on a track. This will bring up the effects view for a track, which shows you the effects for a track.
              </p>
              <p>
                To add an effect, use the <b>Audio FX dropdown</b> in this view, and click on an effect. The effect will be added to the end of the effects chain.
              </p>
              <MiniTrackComponent sequencerEngine={this.props.sequencerEngine}/>
              <div className="two-column">
                <div className="text-column">
                  <p className="sub-header">
                    Effect Parameters
                  </p>
                  <p>
                    Each effect can have several parameters, each changing an
                    aspect of the sound passing through the effect. They are controllable in two ways.
                  </p>
                  <p>
                    <ol>
                      <li>Moving the slider for a parameter. </li>
                      <li>Clicking the value itself, bringing up a text input box to type.</li>
                    </ol>
                  </p>
                  <p>
                    Many effects have a <b>Wet</b> parameter, which controls how much
                    of the signal being passed through will be the effected signal.
                  </p>
                  <p>
                    For example, a reverb with <b>Wet</b> of 100% will only let the
                    reverberated signal through, and none of the original “Dry” signal.
                  </p>
                  <p className="sub-header">
                    Automation
                  </p>
                  <p>
                    Double clicking the name of an effect will bring up the automation
                    lane for that effect parameter in the bottom panel.
                  </p>
                  <p>
                    This allows you to draw in how the parameter changes in time. 
                  </p>
                  <p>
                    For more information, read the <b>Automation</b> documentation.
                  </p>
                </div>
                <div className="text-column">
                  {this.getEffect("Convolver Reverb")}
                 <p>
                    <b>Convolver Reverb Tip</b>
                  </p>
                  <p>
                    You can drag any sample into a convolver reverb to set the reverb’s
                    Impulse Response to that sample. Once dragged, the reverb will take on
                    characteristics of the dragged sample.
                  </p>
                  <p>
                    Water sounds work really well as convolver reverb impulse responses.
                  </p>
                </div>
              </div>
              <div className="two-column">
                <div className="text-column">
                  <p className="sub-header">Parameter Modulation</p>
                  <p>
                    Each parameter can be <b>modulated</b> by either <b>LFOs</b> or <b>Envelopes</b>.
                    Modulation means the parameter changes in a way controlled by the modulator.
                  </p>
                  <p>
                    There are 2 types of <b>modulators</b>.
                  </p>
                  <ol>
                    <li>
                      LFO
                    </li>
                    <li>
                      Envelope
                    </li>
                  </ol>
                  <p>
                    Parameter modulations can be accessed by <b>clicking the parameter name</b>.
                    Once clicked, you’ll see 4 squares and 4 circles. The squares and circles each
                    represent different LFOs and Envelopes, respectively. 
                  </p>
                  <p>
                    To connect to a modulator, just click on the square or circle to toggle them on/off.
                  </p>
                  <p>
                    For more information on modulation, read the <DocLink name="Parameter Modulators" goToLink={this.props.goToLink}/> documentation.
                  </p>
                </div>
                <div className="text-column">
                  {this.getEffect("Filter")}
                  <p>
                    <b>Filter Tip</b>
                    <p>
                      Filters are used to filter out a range of frequencies. The dropdown
                      lets you select which mode of frequencies to filter out.
                    </p>
                    <p>When in <b>Lowpass</b> mode, all frequencies above the <b>Cutoff</b>
                      are filtered out. When in <b>Highpass</b> mode, all frequencies below the <b>Cutoff</b>
                      are filtered out. 
                    </p>
                  </p>
               </div>
              </div>
              <p className="sub-header">
                Moving Effects
              </p>
              <p>
                You can change the order of the effects by dragging the effects to the desired position,
                dragging from the top bar of the effect.
              </p>
              <p className="sub-header">
                Copy and Paste
              </p>
              <p>
                When an effect is selected, you’ll notice a light glow around the effect.
                When selected you can use CMD+c or Ctrl+c to copy that effect.
              </p>
              <p>
                To paste it, select the desired track you wish to paste that effect on,
                and open the “FX” panel for that track. Then use CMD+v or Ctrl+v to paste the copied effect.
              </p>
              <p className="sub-header">
                Effect Presets
              </p>
              <p>
                You might come across a nice setting for an effect that you want to save for later use.
              </p>
              <p>
                To save it, click the floppy disk icon on the bottom right of an effect.
                This will bring you to the <b>Effect Preset View</b>. When in that view, you can type
                of the preset and hit save. The saved preset will appear whenever you go back to
                the <b>Effect Preset View</b> for a given effect.
              </p>
              <p className="sub-header">
                Sends
              </p>
              <p>
                The sliders labeled <b>A</b> and <b>B</b> control how much signal goes to each send.
              </p>
              <p>
                <b>Send A</b> is set to reverb by default, and <b>Send B</b> is set to Delay.
              </p>
              <p>
                For more information on sends, go to the <DocLink name="Sends" goToLink={this.props.goToLink}/> documentation page.
              </p>
              <p className="sub-header">
                Effect Rack
              </p>
              <p>
                The <b>Effect Rack</b> is an effect that allows you to create more advanced effects, using
                a patching interface. For more information, go to the Effect Rack documentation.
              </p>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let track = props.sequencerEngine.tracks && props.sequencerEngine.tracks[0];
    if (track) {
        return {
            numEffects: track.effects.length
        };
    }
    return {
        numEffects: 0
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedEffect: (id) => dispatch(setSelectedEffect(id)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(EffectsDocumentation);
